export var createTestAudioContextOptionsSupport = function createTestAudioContextOptionsSupport(nativeAudioContextConstructor) {
  return function () {
    if (nativeAudioContextConstructor === null) {
      return false;
    }

    var audioContext;

    try {
      audioContext = new nativeAudioContextConstructor({
        latencyHint: 'balanced'
      });
    } catch (_unused) {
      return false;
    }

    audioContext.close();
    return true;
  };
};